import { render } from "./BusinessOpportunity.vue?vue&type=template&id=4e54bb1a&scoped=true&ts=true&lang=pug"
import script from "./BusinessOpportunity.vue?vue&type=script&setup=true&lang=ts"
export * from "./BusinessOpportunity.vue?vue&type=script&setup=true&lang=ts"

import "./BusinessOpportunity.vue?vue&type=style&index=0&id=4e54bb1a&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e54bb1a"]])

export default __exports__